import general from './general.json';
import utilization from './account/utilization.json';
import { NestedMessagesType } from '../../types/locale';

const locales_en_US: NestedMessagesType = {
  ...general,
  account: {
    utilization,
  },
};

export default locales_en_US;
